import { render, staticRenderFns } from "./ActionsForm.vue?vue&type=template&id=1089344c"
import script from "./ActionsForm.vue?vue&type=script&lang=js"
export * from "./ActionsForm.vue?vue&type=script&lang=js"
import style0 from "./ActionsForm.vue?vue&type=style&index=0&id=1089344c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports